module.exports = Promise.all([__parcel__import__("bDcoT"), __parcel__import__("5ARIs")]).then(() => parcelRequire('g36Vt'));